export const PLAN_API = {
    'life': '/services/api/v1/rb_masters/life-plans',
    'health': '/services/api/v1/rb_masters/health-plans',
};